import { h, Component } from 'preact';
import { IEmptyState, ISuperHeaderTagProps } from '../sgwt-super-header.types';

export default class SuperHeaderTags extends Component<ISuperHeaderTagProps, IEmptyState> {
  constructor(props: ISuperHeaderTagProps) {
    super(props);
  }

  render(props: ISuperHeaderTagProps): JSX.Element {
    let environmentTag;
    let navigateAsTag;
    if (props.environment) {
      environmentTag =
        <span class="label sgwt-super-header-tag sgwt-super-header-environment-tag">
          <i class="fa fa-code"/> {props.environment} <i class="fa fa-code"/>
        </span>;
    }
    if (props.navigateAs && props.navigateAs.name) {
      navigateAsTag =
        <span class="label label-primary sgwt-super-header-tag sgwt-super-header-navigation-as-tag">
          {props.labels.navigateAs} {props.navigateAs.name}
          <i class="fa fa-times" onClick={() => props.stopNavigationAs()}/>
        </span>;
    }
    return (
      <div class="sgwt-super-header-tags">
        {environmentTag}
        {navigateAsTag}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/sgwt-super-header/components/SuperHeaderTags.tsx